<template>
    <footer class="footer">
        <span>v0.1.0</span>
        <span class="pull-right"><strong>Travelcab</strong> &copy; {{ currentYear }}</span>
    </footer>
</template>
<script>

export default {
    data() {
        return {
            currentYear: new Date().getFullYear(),
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue